export const LOCAL_PROFILE_ID = String(-1)

export const UNSAVED_PROFILE_NAME = 'Unsaved Profile'

export const NEW_PROFILE_NAME = 'New Profile'
